<template>
  <div class="body-bg-color" :style="[customCss]">
    <!-- <post-markup class="body-bg-color"> -->
    <post-markup
      class="body-bg-color"
      :class="
        this.activeTheme == 1
          ? 'light-theme'
          : this.activeTheme == 2
          ? 'dark-theme'
          : this.activeTheme == 3
          ? 'custom-theme-settings'
          : 'no-theme'
      "
      :courseSettings="courseSettings"
    >
      <template slot="header">
        <post-header :getThemeSettings="getThemeSettings" v-if="isPreview">
          <template slot="logo">
            <header-logo
              v-if="isPreview"
              :logoPath="membershipMasterData.logo"
              :logoSize="membershipMasterData.logo_size"
              :altText="'Header Logo'"
            ></header-logo>
          </template>
          <template slot="menus">
            <menu-items
              :isPreview="isPreview"
              :position="'header'"
              :activeMenus="activeHeaderMenu"
              :sendToPath="sendToPath"
            ></menu-items>
          </template>
          <template slot="profile" v-if="user">
            <header-profile
              :user="user"
              :openProfilePopup="openProfilePopup"
              :logoutUser="logoutUser"
              :isPortal="isPortal"
              :backPortalPage="backPortalPage"
              :profileLabel="membershipMasterData.gen_settings && JSON.parse(membershipMasterData.gen_settings).profile_label"
            :logoutLabel="membershipMasterData.gen_settings &&  JSON.parse(membershipMasterData.gen_settings).logout_label"
            ></header-profile>
          </template>
          <template slot="button" v-else>
            <post-button
              :buttonText="'Log In'"
              :buttonCallback="() => {}"
              :callbackParam="1"
              :specialHover="1"
              :getThemeSettings="getThemeSettings"
            ></post-button>
          </template>
        </post-header>
      </template>
      <template slot="banner-avatar">
        <banner-avatar
          :isPreview="isPreview"
          :files="files.filter((file) => file.mime_type === 'audio/mpeg')"
          :calledFrom="`post`"
          :featuredImage="activeElement.value.featured_image"
          :featuredVideoEmbed="activeElement.value.featured_video"
          :featuredAudio="activeElement.value.featured_audio"
          :overlayColor="
            activeElement.value.configuration_options.overlay_color
          "
          :updateFeaturedImage="updateBannerFeaturedImage"
          :updateFeaturedVideo="updateBannerFeaturedVideo"
          :updateFeaturedAudio="updateBannerFeaturedAudio"
          :updateOverlay="updateBannerOverlayColor"
          :updateType="updateBannerType"
          :bannerSettings="activeElement.value.configuration_options"
          :lockedStatus="activeElement.value.is_locked.status"
        ></banner-avatar>
      </template>
      <template slot="breadcrumb">
        <!-- <filters class="membership-layout-container"></filters> -->
        <breadcrumb
          :isPreview="isPreview"
          :hierarchy="hierarchy"
          :activeElement="activeElement"
          :activateElement="activateElement"
          :sendToPath="sendToPath"
          :getThemeSettings="getThemeSettings"
          :courseSettings="courseSettings"
          :getHomeMenuData="getHomeMenuData"
        ></breadcrumb>
      </template>

      <template slot="mark-as-complete">
        <mark-as-complete>
          <template slot="title">
            <span
              v-if="!activeElement.value.is_locked.status"
              class="inter-font-regular"
            >
              {{ activeElement.value.name }}
            </span>
          </template>
          <template slot="button">
            <template-button
              v-if="!activeElement.value.is_locked.status"
              class="w-full blue-button"
              :buttonText="
                activeElement.value.is_completed
                  ? 'Completed'
                  : courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.markAsCompleteLabel? courseSettings.gen_settings.markAsCompleteLabel:''
              "
              :buttonCallback="markAsComplete"
              :callbackParam="activeElement.value"
              :specialHover="1"
              :getThemeSettings="getThemeSettings"
            ></template-button>
          </template>
          <template slot="next-or-previous-lesson">
            <course-tile
              :getThemeSettings="getThemeSettings"
              v-if="prevEl || nextEl"
            >
              <template slot="course-tile-image">
                <div
                  @click="
                    activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                  "
                  class="tile-img cursor-pointer mr-4"
                >
                  <img
                    v-if="nextPrevFeaturedImage"
                    class="w-32 h-20 object-cover rounded-lg"
                    :src="nextPrevFeaturedImage"
                  />
                  <div
                    v-else
                    class="no-image-tile-v2 bg-tile-red text-white text-sm font-bold items-center text-center flex w-32 h-20 rounded-lg justify-center mb-1"
                  >
                    {{ !nextEl ? prevEl.name : nextEl.name }}
                  </div>
                  <!-- <div v-else class="no-image-tile-v2 tile-red text-white text-sm font-bold items-center text-center flex w-full h-20 rounded-lg">SOCIAL MEDIA ADVERTISING</div> -->
                </div>
              </template>
              <template slot="course-tile-title">
                <span
                  class="cursor-pointer section-heading-color"
                  @click="
                    activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                  "
                  >{{ !nextEl ? prevEl.name : nextEl.name }}
                </span>
              </template>
              <template slot="course-tile-description">
                <span
                  class="cursor-pointer section-content-color"
                  @click="
                    activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                  "
                  >{{ !nextEl ? prevEl.description : nextEl.description }}
                </span>
              </template>
              <template slot="course-tile-type">
                <div
                  @click="
                    activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                  "
                  class="cursor-pointer inter-font-regular w-full h-full flex justify-center items-center"
                >
                  <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.viewLessonLabel">{{ courseSettings.gen_settings.viewLessonLabel }}</span>
                  <span v-else>View Lesson</span>
                </div>
              </template>
            </course-tile>
          </template>
          <template slot="next-or-previous-buttons">
            <div
              @click="scrollToTop('top-anchor')"
              class="flex justify-between w-full"
            >
              <div
                v-if="prevEl"
                class="text-sm w-1/2 text-left prev-lesson cursor-pointer"
                @click="activateElement({ e: '', el: prevEl })"
              >
                <span class="inline-block align-middle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path
                      d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
                    />
                  </svg>
                </span>
                <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.previousLessonLabel">{{ courseSettings.gen_settings.previousLessonLabel }}</span>
                <span v-else>Previous Lesson</span>
              </div>

              <div
                v-if="nextEl"
                class="text-sm w-full text-right next-lesson cursor-pointer"
                @click="activateElement({ e: '', el: nextEl })"
              >
                <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.nextLessonLabel">{{ courseSettings.gen_settings.nextLessonLabel }}</span>
                <span v-else>Next Lesson</span>

                <span class="inline-block align-middle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path
                      d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </template>
        </mark-as-complete>
      </template>
      <template slot="post-canvas"
        ><div
          v-if="loading"
          style="height: 50vh"
          class="flex items-center justify-center"
        >
          <half-circle-spinner
            style="display: block; margin: 0 auto"
            :animation-duration="1000"
            :size="60"
            :color="loaderColor"
          />
        </div>

        <post-canvas
          v-if="!activeElement.value.is_locked.status"
          :isPreview="isPreview"
          :files="files"
          :getThemeSettings="getThemeSettings"
          :getSections="getSections"
          :addNewSection="addNewSection"
          :deleteSection="deleteSection"
          :moveSection="moveSection"
          :cloneSection="cloneSection"
          :updateSectionTitle="updateSectionTitle"
          :updateSectionContent="updateSectionContent"
        ></post-canvas>
        <locked-post
          v-else
          :isPreview="isPreview"
          :offer="activeElement.value.is_locked.offer"
          :unlockDate="activeElement.value.is_locked.unlock_date"
          :getThemeSettings="getThemeSettings"
        ></locked-post>
      </template>

      <template slot="lesson-playlist">
        <lessons-playlist :getThemeSettings="getThemeSettings">
          <template slot="title">
            <div class="flex items-center">
              <div @click="scrollToTop('top-anchor')">
                <span
                  class="cursor-pointer"
                  v-if="activeElement.position.pIndex > -1"
                  @click="
                    !isPreview
                      ? activateElement({ e: '', el: prevEl })
                      : sendToPath({
                          name: 'post',
                          params: { id: prevEl.slug },
                        })
                  "
                >
                  <i class="fa fa-chevron-left mx-1" />
                </span>
              </div>
              <span class="ml-2">{{ activeElement.value.name }}</span>
            </div>
          </template>
          <template slot="lessons-count">
            <span>{{ lessonsCount }} Lesson(s)</span>
          </template>

          <template slot="lessons-list">
            <lessons-tile
              v-for="(item, index) in listElements"
              :key="`${index}-${item.featured_image}-${item.featured_video}`"
              :featuredImage="item.featured_image"
              :featuredVideoEmbed="item.featured_video"
              :isActive="activeElement.value.id == item.id"
              :bannerSettings="item.configuration_options"
              :getThemeSettings="getThemeSettings"
            >
              <template slot="tile-count">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="tile-name">
                <div @click="scrollToTop('top-anchor')">
                  <span
                    class="cursor-pointer inter-font-regular"
                    @click="
                      !isPreview
                        ? item.type === 'post'
                          ? activateElement({ e: '', el: item })
                          : activateElement({
                              e: '',
                              el: item.children.length
                                ? item.children[0]
                                : item,
                            })
                        : item.type === 'post'
                        ? sendToPath({
                            name: 'post',
                            params: { id: item.slug },
                          })
                        : sendToPath({
                            name: 'post',
                            params: {
                              id: item.children.length
                                ? item.children[0].slug
                                : item.slug,
                            },
                          })
                    "
                  >
                    {{ item.name }}
                  </span>
                </div>
              </template>
              <template slot="tile-progress-status">
                <span :class="[item.is_completed ? 'visible' : 'hidden']">
                  <i class="fa fa-check" />
                </span>
                <span
                  v-if="item.type === 'subcategory'"
                  @click="
                    !isPreview
                      ? item.type === 'subcategory'
                        ? activateElement({
                            e: '',
                            el: item.children.length ? item.children[0] : item,
                          })
                        : () => {}
                      : item.type === 'subcategory'
                      ? sendToPath({
                          name: 'post',
                          params: {
                            id: item.children.length
                              ? item.children[0].slug
                              : item.slug,
                          },
                        })
                      : () => {}
                  "
                >
                  <div @click="scrollToTop('top-anchor')">
                    <i class="fa fa-chevron-right" />
                  </div>
                </span>
              </template>
            </lessons-tile>
          </template>
        </lessons-playlist>
      </template>
      <template slot="course-instructor">
        <instructor
          v-if="instructors.length"
          :instructors="instructors"
          :getThemeSettings="getThemeSettings"
        >
        </instructor>
      </template>
      <template slot="progress-bar">
        <progress-bar
          :label="progressBarLabel"
          :completed="completedLessons"
          :total="totalLessons"
          :getThemeSettings="getThemeSettings"
        >
        </progress-bar>
      </template>
      <template slot="download-section">
        <section-wrapper
          v-if="
            !isPreview ||
            (isPreview &&
              sidebarDownloadSection.index > -1 &&
              sidebarDownloadSection.section_content.items.length > 0)
          "
          class="section-bg-color relative shadow-lg download-section"
          :isPreview="true"
          :index="sidebarDownloadSection.index"
          :length="getSections().length"
          :deleteSection="() => {}"
          :moveSection="() => {}"
          :cloneSection="() => {}"
        >
          <template slot="title">
            <title-wrapper
              class="section-heading-color"
              v-if="!isPreview && sidebarDownloadSection.index > -1"
            >
              <quill-editor
                :value="sidebarDownloadSection.name_markup"
                :options="getQuillEditorOptions(null)"
                @change="
                  updateSectionTitle($event, sidebarDownloadSection.index)
                "
                @ready="onEditorReady($event)"
              ></quill-editor>
            </title-wrapper>
            <title-wrapper
              class="section-heading-color"
              v-else
              v-html="sidebarDownloadSection.name_markup"
            >
            </title-wrapper>
          </template>
          <template slot="content">
            <content-wrapper class="section-content-color">
              <download-content
                v-if="sidebarDownloadSection.index > -1"
                :isPreview="isPreview"
                :index="sidebarDownloadSection.index"
                :getThemeSettings="getThemeSettings"
                :files="files"
                :content="sidebarDownloadSection.section_content"
                @updateSectionContent="
                  updateSectionContent($event, sidebarDownloadSection.index)
                "
              >
              </download-content>
              <template-button
                v-else
                class="w-full"
                :buttonText="'Add Download Section'"
                :buttonCallback="addSidebarDownloadSection"
                :callbackParam="null"
                :specialHover="1"
                :getThemeSettings="getGroovePinkButton"
              ></template-button>
            </content-wrapper>
          </template>
        </section-wrapper>
      </template>
      <template slot="footer">
        <post-footer :getThemeSettings="getThemeSettings" v-if="isPreview">
          <template slot="logo">
            <footer-logo
              v-if="isPreview"
              :logoPath="membershipMasterData.footer_logo"
              :altText="'Footer Logo'"
              :logoSize="membershipMasterData.footer_logo_size"
            ></footer-logo>
          </template>
          <template slot="menus">
            <menu-items
              :isPreview="isPreview"
              :position="'footer'"
              :activeMenus="activeFooterMenu"
              :sendToPath="sendToPath"
            ></menu-items>
          </template>
        </post-footer>
      </template>
    </post-markup>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import PostMarkup from './post-markup';

import PostHeader from '../../../common/header/header';
import HeaderLogo from '../../../common/header/logo';
import HeaderProfile from '../../../common/header/profile';

import BannerAvatar from '../../../common/banner/avatar/avatar';

import LessonsPlaylist from '../../../common/lessons-playlist/lessons-playlist';
import LessonsTile from '../../../common/lessons-playlist/tile';

import PostCanvas from '../../../common/canvas/canvas';
import LockedPost from '../../../common/lockedPost';

import Instructor from '../../../common/instructor';
import ProgressBar from '../../../common/progressBar';

import SectionWrapper from '../../../common/canvas/wrapper/section';
import TitleWrapper from '../../../common/canvas/wrapper/title';
import ContentWrapper from '../../../common/canvas/wrapper/content';
import DownloadContent from '../../../common/canvas/content/download';
import defaultSectionsHelper from '../../../common/canvas/defaultSections';

import CourseTile from '../../../common/tile/tile-v-2';
import TemplateButton from '../../../common/button';
import MarkAsComplete from '../../../common/mark-as-complete';

import flatTreeHelper from '../../../../../helpers/flatTree';
import Breadcrumb from '../../../common/breadcrumb';

import PostFooter from '../../../common/footer/footer';
import FooterLogo from '../../../common/footer/logo';

import MenuItems from '../../../common/menuItems';

import { HalfCircleSpinner } from 'epic-spinners';

import BackIcon from '../../../../../assets/images/icons/back.svg';
import BackArrow from '../../../../../assets/images/icons/arrowright.svg';
import TickIcon from '../../../../../assets/images/icons/tick.svg';

import quillMixin from '../../../mixins/quill';

export default {
  name: 'PostTemplate',
  mixins: [quillMixin],
  components: {
    PostMarkup,
    PostHeader,
    HeaderLogo,
    HeaderProfile,
    BannerAvatar,
    LessonsPlaylist,
    LessonsTile,
    PostCanvas,
    LockedPost,
    Instructor,
    ProgressBar,
    SectionWrapper,
    TitleWrapper,
    ContentWrapper,
    DownloadContent,
    CourseTile,
    Breadcrumb,
    TemplateButton,
    MarkAsComplete,
    BackIcon,
    BackArrow,
    TickIcon,
    PostFooter,
    FooterLogo,
    MenuItems,
    HalfCircleSpinner,
  },
  data() {
    return {
      nextPrevFeaturedImage: '',
      loaderColor: '#FD6481',
      featuredVideoEmbed: '',
      featuredVideoSrc: '',
      playableSource: 'https://www.youtube.com/embed/tgbNymZ7vqY',
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    openProfilePopup: {
      type: Function,
      default: () => {},
    },
    logoutUser: {
      type: Function,
      default: () => {},
    },
    files: {},
    instructors: {},
    hierarchy: {},
    activeElement: {},
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    activeHeaderMenu: {
      type: Array,
      default: () => [],
    },
    activeFooterMenu: {
      type: Array,
      default: () => [],
    },
    getThemeSettings: {},
    addNewSection: {
      type: Function,
      default: () => {},
    },
    deleteSection: {
      type: Function,
      default: () => {},
    },
    moveSection: {
      type: Function,
      default: () => {},
    },
    cloneSection: {
      type: Function,
      default: () => {},
    },
    updateSectionTitle: {
      type: Function,
      default: () => {},
    },
    updateSectionContent: {
      type: Function,
      default: () => {},
    },
    membershipMasterData: {},
    updateBannerFeaturedImage: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedVideo: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedAudio: {
      type: Function,
      default: () => {},
    },
    updateBannerOverlayColor: {
      type: Function,
      default: () => {},
    },
    updateBannerType: {
      type: Function,
      default: () => {},
    },
    totalLessons: {
      required: true,
    },
    completedLessons: {
      required: true,
    },
    markAsComplete: {
      type: Function,
      default: () => {},
    },
    activeTheme: {},
    isPortal: {
      type: Boolean,
      default: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
    courseSettings: {},
  },
  computed: {
    getHomeMenuData() {
        return this.activeHeaderMenu.find(item => item.is_default==1);
    },
    getGroovePinkButton() {
      return () => {
        return {
          button_section: {
            bg_color: 'rgba(253, 100, 129, 1)',
            text_color: 'rgba(255, 255, 255, 1)',
          },
        };
      };
    },
    loading() {
      if (this.activeElement.value.is_locked.status) {
        return false;
      }
      return !this.activeElement.sectionsLoaded;
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--template-section-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--template-section-heading-color': this.themeSettings
          .configuration_options.section_heading_color,
        '--template-section-content-color': this.themeSettings
          .configuration_options.section_content_color,
      };
    },
    getSections() {
      return () => {
        return this.activeElement.value.sections;
      };
    },
    sidebarDownloadSection() {
      if (this.getSections().length < 1) {
        return {
          index: -1,
          name_markup: null,
          section_content: null,
        };
      }

      const index = this.getSections().findIndex((el) => {
        return (
          el.type === 'download-component' &&
          el.section_content.hasOwnProperty('showInSidebar') &&
          el.section_content.showInSidebar
        );
      });

      if (index > -1) {
        return {
          index,
          name_markup: this.activeElement.value.sections[index].name_markup,
          section_content: this.activeElement.value.sections[index]
            .section_content,
        };
      }

      return {
        index: -1,
        name_markup: null,
        section_content: null,
      };
    },
    listElements() {
      const { cIndex, sIndex, pIndex } = this.activeElement.position;

      if (cIndex > -1 && sIndex > -1 && pIndex > -1) {
        return this.hierarchy[cIndex].children[sIndex].children.filter(
          (el) => !el.is_hidden
        );
      }

      if (cIndex > -1 && sIndex > -1 && pIndex < 0) {
        return this.hierarchy[cIndex].children.filter((el) => !el.is_hidden);
      }

      if (cIndex > -1 && sIndex < 0 && pIndex < 0) {
        return this.hierarchy.filter((el) => !el.is_hidden);
      }

      return [];
    },
    grandpaa() {
      const { cIndex, sIndex, pIndex } = this.activeElement.position;

      if (cIndex > -1 && sIndex > -1 && pIndex > -1) {
        return this.hierarchy[cIndex].children[sIndex].children;
      }

      if (cIndex > -1 && sIndex > -1 && pIndex < 0) {
        return this.hierarchy[cIndex].children;
      }

      if (cIndex > -1 && sIndex < 0 && pIndex < 0) {
        return this.hierarchy;
      }
    },
    progressBarLabel() {
      return `${this.completedLessons} of ${this.totalLessons} lessons completed`;
    },
    flatHierarchy() {
      return flatTreeHelper([], this.hierarchy).filter(
        (el) => el.type === 'post'
      );
    },
    nextEl() {
      const index = this.flatHierarchy.findIndex(
        (el) => el.id == this.activeElement.value.id
      );
      const length = this.flatHierarchy.length;

      if (length == index + 1) return null;

      return this.flatHierarchy[index + 1];
    },
    prevEl() {
      const index = this.flatHierarchy.findIndex(
        (el) => el.id == this.activeElement.value.id
      );
      const length = this.flatHierarchy.length;

      if (!index) return null;

      return this.flatHierarchy[index - 1];
    },
    lessonsCount() {
      return this.listElements.filter((child) => child.type === 'post').length;
    },
    nextPrevEl() {
      return this.nextEl ? this.nextEl : this.prevEl;
    },
  },
  methods: {
    scrollToTop(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
    addSidebarDownloadSection() {
      const obj = defaultSectionsHelper();

      obj.download.section_content.showInSidebar = true;
      obj.download.name = 'Downloads';
      obj.download.name_markup = '<p>Downloads</p>';
      return this.addNewSection(obj.download);
    },
    async loadThumbnail(featuredVideoEmbed) {
      try {
        var doc = new DOMParser().parseFromString(
          featuredVideoEmbed,
          'text/html'
        );

        let str = doc.all[3];
        let id = str.getAttribute('id');
        let permalink = str.getAttribute('permalink');

        const videoData = await api.get(
          `${window.config.apiCoreUrl}/groovevideo/fetch-with-permalink?permalink=${permalink}&id=${id}`
        );

        return videoData.data.thumbnail;
      } catch (err) {
        console.log({ err });
      }
    },
  },
  watch: {
    nextPrevEl: {
      deep: true,
      async handler(newValue, oldValue) {
        if (!newValue) {
          this.nextPrevFeaturedImage = '';
        }

        const bannerType = newValue.configuration_options.hasOwnProperty(
          'banner_type'
        )
          ? newValue.configuration_options.banner_type
          : 'image';

        if (bannerType === 'image') {
          this.nextPrevFeaturedImage = newValue.featured_image;
        } else if (bannerType === 'video') {
          this.nextPrevFeaturedImage = await this.loadThumbnail(
            newValue.featured_video
          );
        } else {
          this.nextPrevFeaturedImage = '';
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.body-bg-color {
  background-color: var(--template-body-bg-color);
}
.section-bg-color {
  background-color: var(--template-section-bg-color);
}
.section-heading-color {
  color: var(--template-section-heading-color);
}
.section-content-color {
  color: var(--template-section-content-color);
}
</style>
<style lang="scss">
.light-theme {
  .active-playlistVideo {
    background-color: #f3f3f3;
  }
  .text-wrapper-t2-tile {
    .description span {
      color: #a1a1a1 !important;
    }
  }
  .playlist .custom-scrollbars {
    border-top: 1px solid #efeff5;
  }
  .blue-button {
    background: #363e5e;
    border: #363e5e;
    opacity: 1;
    &:hover {
      background: #363e5e;
      border: #363e5e;
      opacity: 1;
    }
  }
}
.dark-theme {
  .download-section {
    .section-content-color .custom-selectbox {
      color: #333;
    }
  }
}
.template-two-sidebar {
  .download-section {
    font-family: 'Inter';
    .p-6 {
      padding: 24px;
    }
    .section-title {
      p {
        font-size: 16px !important;
        font-weight: 600;
        font-family: 'Inter';
        letter-spacing: 0.45px;
      }
    }
  }
  .instructor-box {
    font-family: 'Inter';
    .instructor-title {
      font-size: 16px;
      font-weight: 600;
      font-family: 'Inter';
      letter-spacing: 0.45px;
    }
    .instructor-list-item {
      padding: 0px;
      font-family: 'Inter';
      letter-spacing: 0.45px;
    }
  }
}
.next-lesson,
.prev-lesson {
  .inline-block svg {
    width: 10px;
    margin-top: -2px;
  }
}
</style>
